import * as _ from 'lodash';
import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from '../';
import { IBaseResponse, ICenterBase, IGpsDevice, IListItem } from '@nkr/models/index';

export interface IGpsDeviceListResponse {
    data: {
        success: boolean,
        message: string,
        results: IGpsDevice[]
    }
}
export interface IGpsLookupDataResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            categoryList: IListItem[],
            clusterList: IListItem[],
            centerList: ICenterBase[],
            positionList: IListItem[],
            chainList: IListItem[],
            statusList: IListItem[],
            patientTypeList: IListItem[]
        }
    }
}
export interface IAddGpsDeviceResponse {
    data: {
        success: boolean,
        message: string,
        results: number
    }
}

export interface IVerifyGpsNumberResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            exists: boolean
        }
    }
}

export const ActionCreators = {
    getGpsDeviceList: () => async (dispatch: Dispatch<IApplicationState>): Promise<IGpsDeviceListResponse> => {
        let options = {
            url: `${__API__}/admin/gps/devices`,
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    getGpsLookupData: () => async (dispatch: Dispatch<IApplicationState>): Promise<IGpsLookupDataResponse> => {
        let options = {
            url: `${__API__}/admin/gps/lookup-data`,
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    updateGpsDevice: (deviceId: number, imei: string, gpsNumber: number, vendor: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/admin/gps/device/${deviceId}`,
            data: {
                imei,
                gpsNumber,
                vendor
            }
        }

        return await dispatch(AuthActionCreators.apiPut(options));
    },
    addGpsDevice: (imei: string, gpsNumber: number, vendor: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IAddGpsDeviceResponse> => {
        var options = {
            url: `${__API__}/admin/gps/device`,
            data: {
                imei,
                gpsNumber,
                vendor
            }
        }

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    deleteGpsDevice: (deviceId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/admin/gps/device/${deviceId}`
        }

        return await dispatch(AuthActionCreators.apiDelete(options));
    },
    verifyGpsNumber: (deviceId: number, gpsNumber: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IVerifyGpsNumberResponse> => {
        let options = {
            url: `${__API__}/admin/gps/device/verify-gps-number?deviceId=${deviceId}&gpsNumber=${gpsNumber}`,
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
}

export interface IGpsState {
}

let initialState: IGpsState = {

};

const createReducer = (initialState: IGpsState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = Object.assign({}, state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
};

export const Reducer = createReducer(initialState, handlers);
